var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtAutoinsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M20.209.404C18.412 2.828 5.659 8 1 8c-.552 0-1 .448-1 1v19c0 4.356 3.765 8.939 9.989 13.542 3.998 2.956 9.532 6.101 10.766 6.413.16.041.33.041.49 0 1.103-.28 6.692-3.565 10.762-6.542C38.243 36.853 42 32.643 42 29V9c0-.552-.448-1-1-1C36.021 8 23.676 2.915 21.815.405c-.4-.54-1.206-.54-1.606 0zm.796 2.013l.092.08C24.56 5.396 34.472 9.41 39.893 9.942l.106.009L40 29c0 2.742-3.463 6.623-9.173 10.799-2.154 1.575-4.508 3.103-6.74 4.415l-.92.531c-.849.482-1.59.88-2.024 1.096l-.15.073-.062-.028c-.568-.262-1.773-.884-3.03-1.598-2.252-1.28-4.585-2.774-6.723-4.355l-.371-.276C5.288 35.506 2 31.429 2 28V9.945l.056-.005c5.22-.539 15.4-4.61 18.876-7.461l.073-.062z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    d: "M11.963 19.292l1.302-2.931c.274-.822 1.037-1.375 1.898-1.375h11.675c.861 0 1.624.553 1.933 1.466l1.317 2.955c.02.045.042.088.07.129l.282.444c-.803.553-1.676 1.006-2.44 1.006H14c-.685 0-1.458-.366-2.19-.84l.153-.854zM36 17.986h-3c-.109 0-.474.323-.98.754l-.137-.215-1.25-2.796c-.546-1.64-2.07-2.743-3.795-2.743H15.163c-1.724 0-3.249 1.103-3.76 2.652l-1.316 2.952c-.027.061-.044.126-.059.191-.53-.451-.915-.795-1.028-.795H6c-.552 0-1 .461-1 1.014v1.344c0 .552.448 1 1 1L8 22v1c-.64.641-1 1.509-1 2.414V27c0 .885.391 1.672 1 2.222V32c0 .553.448.986 1 .986h4c.552 0 1-.433 1-.986v-2.014h14V32c0 .553.448.986 1 .986h4c.552 0 1-.433 1-.986v-2.778c.61-.55 1-1.337 1-2.222v-1.586c0-.905-.359-1.773-1-2.414v-1l2-.656c.552 0 1-.448 1-1V19c0-.553-.448-1.014-1-1.014z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M30.942 22.617c.42-.357 1.052-.305 1.409.116s.305 1.052-.116 1.41C30.845 25.32 28.89 26 27 26c-.552 0-1-.448-1-1s.448-1 1-1c1.43 0 2.923-.52 3.942-1.383zM9.65 22.733c.357-.421.988-.473 1.41-.116C12.078 23.481 13.572 24 15 24c.552 0 1 .448 1 1s-.448 1-1 1c-1.89 0-3.845-.68-5.234-1.857-.421-.358-.473-.989-.116-1.41z",
    transform: "translate(3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtAutoinsurance);
export default __webpack_public_path__ + "static/media/art-autoinsurance.5f6d8608e6d8c492f0e17486ad184c95.svg";
export { ForwardRef as ReactComponent };